import { createAsyncThunk } from '@reduxjs/toolkit';
import { TableFilter } from '../../../../components/Table/models/table-filter';
import { objectToQueryString } from '../../../../utils/queryHelper';
import createNotification from '../../../../utils/createNotification';
import { TimelineParty } from '../models/enums/timeline-party.enum';

export const GetCurrentEvents = createAsyncThunk(
    'engagements/GetCurrentEvents',
    async (
        {
            filterParams,
            engagementId,
            party,
        }: {
            filterParams: TableFilter;
            engagementId: number;
            party: TimelineParty;
        },
        dispatch: any
    ) => {
        const axios = dispatch.getState().core.axios;
        const queryString = objectToQueryString(filterParams);

        try {
            const response = await axios.get(
                `/api/Marketplace/Engagements/${engagementId}/GetCurrentEvents/${party}?${queryString}`
            );
            if (response.status !== 200) {
                createNotification(
                    'Could not fetch Events at the moment.',
                    'error'
                );
                throw new Error('Failed to fetch Events');
            }

            return {
                events: response.data.list,
                pageNumber: response.data.pageNumber,
                totalItems: response.data.totalItems,
                pageSize: response.data.pageSize,
            };
        } catch (error) {
            createNotification(
                'An error occurred while fetching Events.',
                'error'
            );
            throw error;
        }
    }
);
